import { IOutrasBasesNcmEnviar } from 'interfaces/IOutrasBases';
import { removeFormatCurrency } from 'utils/formatCurrency';

const NUMERO_MINIMO = 0.01;
const NUMERO_MAXIMO = 1e11;
const COMPRAS_DE_TERCEIRO = 'COMPRAS DE TERCEIRO';

const validarCampoTexto = (value?: string): boolean => {
  return value == undefined || value === '';
};

const validarCampoNumero = (value?: string) => {
  if (value) {
    const floatValue = parseFloat(value);
    return floatValue < NUMERO_MINIMO || floatValue >= NUMERO_MAXIMO;
  } else {
    return true;
  }
};

const validarCampoFinanceiro = (value?: string) => {
  return value == undefined || removeFormatCurrency(value) < NUMERO_MINIMO || parseFloat(value) > NUMERO_MAXIMO;
};

const validarTipoDeUso = (value?: string) => {
  if (value) {
    return parseFloat(value) == -1;
  } else {
    return true;
  }
};

const retornarCamposObrigatorios = (formValues: IOutrasBasesNcmEnviar) => {
  type ValidacaoCampo = {
    field: string;
    label: string;
    validate?: (value?: string) => boolean;
  };

  const CAMPOS_OBRIGATORIO = [
    { field: 'codigoNcm', label: 'Código NCM' },
    { field: 'unidadeMedida', label: 'Unidade de Medida' },
    { field: 'valorReceitaBruta', label: 'Receita Bruta', validate: validarCampoFinanceiro },
    { field: 'quantidade', label: 'Quantidade', validate: validarCampoNumero },
    { field: 'tipoDeUso', label: 'Tipo de Uso', validate: validarTipoDeUso },
  ];

  const camposObrigatorios: ValidacaoCampo[] = CAMPOS_OBRIGATORIO;

  return camposObrigatorios;
};

const validarCamposObrigatorios = (formValues: IOutrasBasesNcmEnviar) => {
  const camposObrigatorios = retornarCamposObrigatorios(formValues);

  const camposInvalidos = [];

  for (const campo of camposObrigatorios) {
    let testeValidacao = validarCampoTexto;

    if (campo.validate) {
      testeValidacao = campo.validate;
    }

    if (testeValidacao(formValues[campo.field])) {
      camposInvalidos.push(campo.label);
    }
  }

  if (camposInvalidos.length == camposObrigatorios.length) {
    return 'Por favor, preencha corretamente todos os campos';
  } else if (camposInvalidos.length >= 2) {
    return `Por favor, preencha corretamente os campos "${camposInvalidos[0]}" e "${camposInvalidos[1]}"`;
  } else if (camposInvalidos.length == 1) {
    return `Por favor, preencha corretamente o campo "${camposInvalidos[0]}"`;
  } else {
    return '';
  }
};

const validarDeducoes = (
  formvalues: IOutrasBasesNcmEnviar,
  deducoesPossiveis: string[] | undefined,
  haCompraTerceiro: boolean
) => {
  const deducoes = formvalues.tributosIncidentes;
  const valorReceitaBruta = formvalues.valorReceitaBruta;
  const somaDeducoes = deducoes.reduce((acc, deducao) => acc + deducao.valor, 0);

  if (valorReceitaBruta !== undefined && somaDeducoes > valorReceitaBruta) {
    return 'A soma das deduções não pode ser maior que a receita bruta';
  }

  if (deducoesPossiveis && deducoesPossiveis.filter((d) => d !== COMPRAS_DE_TERCEIRO).length > 0) {
    if (!deducoes || deducoes.length === 0) {
      return 'Por favor, preencha corretamente as deduções.';
    }

    if (!haCompraTerceiro && deducoesPossiveis.indexOf(COMPRAS_DE_TERCEIRO) !== -1) {
      deducoesPossiveis.splice(deducoesPossiveis.indexOf(COMPRAS_DE_TERCEIRO), 1);
    }

    if (haCompraTerceiro) {
      let compraTerceiroPesquisada = deducoes.find((ct) => ct.nome === COMPRAS_DE_TERCEIRO);
      if (!compraTerceiroPesquisada || compraTerceiroPesquisada.valor === 0) {
        deducoesPossiveis.splice(deducoesPossiveis.indexOf(COMPRAS_DE_TERCEIRO), 1);
        return 'Você informou que há compra de terceiro. Por favor, informe o valor de aquisição de terceiros.';
      }
    }

    for (const deducao of deducoesPossiveis) {
      let deducaoPesquisada;
      deducaoPesquisada = deducoes.find((item) => item.nome == deducao);
      if (deducaoPesquisada === undefined) {
        return `Nas deduções, informe o valor do ${deducao} mesmo que seja zero`;
      }
    }
  }

  return '';
};

export const validarOutrasBasesCalculoForm = (
  formValues: IOutrasBasesNcmEnviar,
  deducoesPossiveis: string[] | undefined,
  haCompraTerceiro: boolean
) => {
  const validacoes = [validarCamposObrigatorios, validarDeducoes];

  for (const funcao of validacoes) {
    const msgValidacao = funcao(formValues, deducoesPossiveis, haCompraTerceiro);

    if (msgValidacao !== '') {
      return msgValidacao;
    }
  }

  return '';
};
